<template>
    <div>
        <div class="flex items-center justify-between mt-4 mb-2">
            <div class="flex items-center">
                <b-switch v-model="subactivities_progress_groups" :rounded="true" :outlined="false" size="is-small"
                    type="is-success" passive-type="is-info" :left-label="true"
                    @input="setSubactivitiesProgressGroups()"></b-switch>
                <label class="font-bold ml-2">
                    {{ subactivities_progress_groups ? 'Subactividades' : 'Actividades' }} dan progreso a grupos
                </label>

                <div class="relative inline-block w-16 h-16 overflow-hidden ml-2 cursor-pointer group"
                  @click="showHelpModal = true">
                  <img class="w-full h-full object-contain" :src="asset(imageSrc)" alt="Toggle Image" />
                  <div class="absolute inset-0 flex items-center justify-center
                    bg-gray-400 bg-opacity-50 backdrop-blur-sm
                    opacity-0 group-hover:opacity-100 transition-opacity">
                    <i class="fas fa-search text-white"></i>
                  </div>
                </div>

                <b-modal v-model="showHelpModal" title="Imagen Expandida" hide-footer>
                  <img :src="asset(imageSrc)" alt="Expanded Image" class="w-full" />
                </b-modal>
            </div>
            <div>

            </div>
        </div>

        <!-- La "Configuración para reporte detallado" se movió a su propia página
             (ruta project.admin.report-config, icono en la barra de acciones del
             proyecto). Aquí queda solo el ajuste de progreso de grupos. -->

        <activity-group-config-modal ref="refConfigModal"
            :project-id="projectId"
            :subactivities-progress-groups.sync="subactivities_progress_groups"
            :activity-groups="activityGroups"
            @epc-success-save-config="handleSuccessSaveConfig"/>
    </div>
</template>

<script>
import axios from 'axios'
import ActivityGroupConfigModal from './components/config-modal.vue'

import { defaultSections } from './data/default-sections.js'
import { getConfigDetailedReport } from './services/activity-groups.service.js'

export default {
    components: { ActivityGroupConfigModal },
    props: {
        projectId: { type: [String, Number], required: true }
    },
    data() {
      return {
        defatulSections: [...defaultSections],
        configTable: [],
        configDetailedReport: {},
        showHelpModal: false,
        subactivities_progress_groups: false,
        isLoading: false,
        selectedReportGroupIds: [],
        activityGroups: [],

        componetKey: 0, // Used to force re-rendering of the component
      }
    },
    mounted() {
      this.loadActivityGroups()
      this.loadProjectConfig()
      this.getProject()
    },
    computed: {
      imageSrc() {
        return this.subactivities_progress_groups
          ? 'public/progress-group-subactivity.png'
          : 'public/progress-group-activity.png';
      },
    },
    methods: {
      async getProject() {
        const {data} = await axios.get('/api/v2/project/'+ this.projectId)
        if (data) {
          this.subactivities_progress_groups = !!data.subactivities_progress_groups
        }
      },

      async loadProjectConfig() {
          try {
            this.configDetailedReport = await getConfigDetailedReport(this.projectId);

          } catch (e) {
              console.error('Error loading project config:', e);
              this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
          } finally {
              this.isLoading = false;
          }
      },

      async loadActivityGroups() {
          try {
              const { data } = await axios.get(
                  `/api/v2/project/${this.projectId}/activity/groups`,
                  { params: { full_tree: 1 } } // necesitamos el árbol completo para construir el config tree
              )
              this.activityGroups = (data.groups || [])
                  .map(this.mapGroupToTree)
          } catch (e) {
              this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
          }
      },

      mapGroupToTree(g) {
        const node = { id: g.id, label: g.name, parent_id: g.parent_id }
        if (g.children?.length) node.children = g.children.map(this.mapGroupToTree)
        return node
      },

      openConfigReportModal() {
          this.$refs.refConfigModal.show(JSON.parse(JSON.stringify(this.configDetailedReport)))
      },

      async setSubactivitiesProgressGroups() {
          await axios.post("/api/v2/project/" + this.projectId + "/set-subactivities-progress-groups", {
              subactivities_progress_groups: this.subactivities_progress_groups
          });
      },

      handleSuccessSaveConfig(config) {
        this.configDetailedReport = config;
        this.$refs.refConfigModal.hide();
      }
    }
}
</script>